module.exports = __webpack_public_path__ + "img/product-3-shawwer.1d0493f6.png";